import React, { useEffect } from "react";
import Turnstile from "react-turnstile";

/**
 * Cloudflare always-pass test keys (safe for local only):
 * https://developers.cloudflare.com/turnstile/troubleshooting/testing/
 */
export const TURNSTILE_TEST_SITEKEY = "1x00000000000000000000AA";

/** Opt-in only — never infer from NODE_ENV (prod builds can be mislabeled). */
function shouldBypassTurnstile() {
  return process.env.REACT_APP_TURNSTILE_BYPASS === "true";
}

/**
 * Renders Turnstile, or when REACT_APP_TURNSTILE_BYPASS=true supplies a dummy token.
 */
export default function TurnstileField({ onVerify, onExpire, onError }) {
  const bypass = shouldBypassTurnstile();
  const sitekey =
    process.env.REACT_APP_CF_TURNSTILE_SITEKEY || TURNSTILE_TEST_SITEKEY;

  useEffect(() => {
    if (!bypass) return undefined;
    onVerify("dev-bypass");
    return () => {
      if (onExpire) onExpire();
    };
    // Intentionally run once on mount for bypass mode
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bypass]);

  if (bypass) {
    return (
      <p className="help-text" style={{ marginTop: "0.75rem" }}>
        Turnstile bypassed (REACT_APP_TURNSTILE_BYPASS=true).
      </p>
    );
  }

  if (!process.env.REACT_APP_CF_TURNSTILE_SITEKEY) {
    return (
      <p className="message message-error">
        Missing REACT_APP_CF_TURNSTILE_SITEKEY. Set it in `.env`, or for local
        development only set REACT_APP_TURNSTILE_BYPASS=true.
      </p>
    );
  }

  return (
    <Turnstile
      sitekey={sitekey}
      onVerify={onVerify}
      onExpire={onExpire}
      onError={onError}
    />
  );
}
